import styled from 'styled-components'

export const IconButtonContainer = styled.button<{ active?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: ${({ active, theme }) => (active ? '#3366CC' : 'transparent')};
  color: ${({ active, theme }) =>
    active
      ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})`
      : `rgb(${theme.grayscale?.['200'] || '207, 207, 207'})`};
  cursor: pointer;

  &:hover:not(:disabled) {
    color: ${({ theme }) => `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})`};
    background: #3366cc88;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

export const Tooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 10px;
  background: ${({ theme }) => `rgb(${theme.background?.high || '13, 13, 13'})`};
  color: ${({ theme }) => `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})`};
  border-radius: 6px;
  font-size: 0.75rem;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 4px solid transparent;
    border-top-color: ${({ theme }) => `rgb(${theme.background?.high || '13, 13, 13'})`};
  }
`
